import { FC } from 'react';
import styled from 'styled-components';

import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { Import24 } from 'ui/icons';
import { trackTemplateImportButtonClick } from '../../utils';
import { useTemplateFolderModals } from 'modules/templateIndex/templateFolders/hooks/useTemplateFolderModals';

const StyledLink = styled.a`
  &:hover {
    text-decoration: none;
  }
`;

export const ImportTemplateButton: FC<{ isReactFFOn: boolean; text: string }> = ({
  isReactFFOn,
  text,
}) => {
  const modals = useTemplateFolderModals();

  if (isReactFFOn) {
    return (
      <SecondaryButton
        data-testid="import-template-react-button"
        size={BUTTON_SIZES.LARGE}
        onClick={() => {
          modals.import.toggle();
        }}
      >
        <Import24 data-test="import-template-icon" />
        <span data-test="import-template-label">{text}</span>
      </SecondaryButton>
    );
  }

  return (
    <StyledLink
      data-testid="import-template-angular-button"
      onClick={trackTemplateImportButtonClick}
      href="/templates/import"
    >
      <SecondaryButton size={BUTTON_SIZES.LARGE}>
        <Import24 data-test="import-template-icon" />
        <span data-test="import-template-label">{text}</span>
      </SecondaryButton>
    </StyledLink>
  );
};
